import React from 'react';

const Phone: React.FC<{ src: string; alt: string; className?: string }> = ({
  src,
  alt,
  className = '',
}) => (
  <div className={`relative mx-auto w-[260px] sm:w-[280px] ${className}`}>
    <div className="rounded-[2.6rem] bg-gray-950 p-[10px] shadow-2xl ring-1 ring-black/10">
      <img
        src={src}
        alt={alt}
        className="w-full rounded-[2.1rem] bg-[#f4f1ec]"
      />
    </div>
  </div>
);

export default Phone;
